import React, { useState, useEffect, useRef } from "react";
import api from "@/api";

export default function CountryModal({ open, onClose, country, onSaved }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (country) {
      setName(country.name || "");
    } else {
      setName("");
    }
  }, [country, open]);

  // Dismiss on Esc key only (click-away removed)
  useEffect(() => {
    if (!open) return;
    function handleKey(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    const payload = { name };
    const data = country ? { ...payload, id: country.id } : payload;
    api
      .post("/masterdata/countries/store", data)
      .then(() => {
        setSaving(false);
        onSaved();
      })
      .catch(() => setSaving(false));
  }

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div
        ref={modalRef}
        className="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-6 w-full max-w-md relative"
      >
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 className="text-xl font-bold mb-4">
          {country ? "Edit Country" : "Add Country"}
        </h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              className="border rounded px-3 py-2 w-full dark:bg-gray-800 dark:border-gray-700"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </div>
          <button
            type="submit"
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 py-2 rounded shadow disabled:opacity-50"
            disabled={saving}
          >
            {saving ? "Saving..." : country ? "Save Changes" : "Add Country"}
          </button>
        </form>
      </div>
    </div>
  );
}
